import { Alert, Box, Button, Modal, Spinner } from "@cloudscape-design/components";
import MarkdownMessage from "./components/MarkdownMessage";

interface DocumentationModalProps {
  visible: boolean;
  title: string | null;
  markdown: string | null;
  loading: boolean;
  error: string | null;
  onDismiss: () => void;
}

/**
 * Reusable modal that displays server-rendered documentation markdown.
 *
 * The markdown is already substituted and sanitized server-side; it is rendered
 * with the shared MarkdownMessage component, which builds React elements and
 * ignores raw HTML.
 */
export default function DocumentationModal({
  visible,
  title,
  markdown,
  loading,
  error,
  onDismiss,
}: DocumentationModalProps) {
  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      size="max"
      header={title ?? "Documentation"}
      footer={
        <Box float="right">
          <Button variant="primary" onClick={onDismiss}>
            Close
          </Button>
        </Box>
      }
    >
      {loading ? (
        <Spinner size="large" />
      ) : error ? (
        <Alert type="error">{error}</Alert>
      ) : (
        <MarkdownMessage text={markdown ?? ""} />
      )}
    </Modal>
  );
}
